var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPencilAlt(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#pencil-alt_svg__clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.223.778a2.647 2.647 0 00-3.746 0L.609 7.643a.343.343 0 00-.097.197L.003 11.61a.343.343 0 00.098.289.35.35 0 00.242.102c.016 0 .031 0 .046-.002l2.27-.307a.346.346 0 00-.091-.686l-1.82.246.355-2.629 2.766 2.767a.339.339 0 00.486 0l6.868-6.865A2.632 2.632 0 0012 2.65c0-.709-.276-1.373-.777-1.872zm-3.613.844l1.153 1.153-6.267 6.267-1.153-1.153L7.61 1.622zm-3.495 9.036L2.987 9.53l6.267-6.267 1.128 1.128-6.267 6.267zm6.747-6.76l-2.759-2.76c.35-.288.788-.447 1.248-.447A1.954 1.954 0 0111.31 2.65c0 .462-.159.897-.448 1.247z",
    fill: "#9A9A9A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "pencil-alt_svg__clip0"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h12v12H0z"
  })))));
}

export default __webpack_public_path__ + "./fonts/pencil-alt.ef3965ba83d94e3ba9c9f96c1022424a.svg";
export { SvgPencilAlt as ReactComponent };